import { applyMiddleware, combineReducers, createStore } from 'redux';
import thunk from 'redux-thunk';
import { IAddOnsState } from '../classes/add-ons';
import { IAddOnsAppSettings } from '../custom/classes/add-ons-settings';
import { IAddOnsAppText } from '../custom/classes/add-ons-text';
import { updateSettings, loadProductions } from './actions/add-ons.actions';
import addOnsReducer from './reducers/add-ons.reducer';
import addOnsSettingsReducer from './reducers/add-ons-settings.reducer';
import addOnsTextReducer from './reducers/add-ons-text.reducer';


declare const pageData: any;
declare const viewModel: any;

export interface IAddOnsAppState {
    addOns: IAddOnsState;
    addOnsText: IAddOnsAppText;
    addOnsSettings: IAddOnsAppSettings;
}

const appReducer = combineReducers({
    addOns: addOnsReducer,
    addOnsText: addOnsTextReducer,
    addOnsSettings: addOnsSettingsReducer
});

//let calendarSettings = {
//    ...defaultCalendarSettings
//};

const appStore = createStore(appReducer, {
    //calendarSettings: calendarSettings
}, applyMiddleware(thunk));


//if (window.location.hash.length > 1) {
//    GetFilterFromQuery(window.location.hash, appStore);
//}

appStore.dispatch(updateSettings(pageData) as any);
appStore.dispatch(loadProductions(viewModel.addOns));

export { appStore };
